import { AxiosResponse, AxiosRequestConfig } from 'axios';
import { get } from 'lodash/fp';
import TokenExpiryTimer from '../TokenExipiryTimer';
import { VIEW } from '../../interfaces';
import * as configService from '../configService';

const isHeadlessMode = () => {
    return typeof window === 'undefined' || configService.isInternal();
};

const isExportPath = () => {
    const href = get('location.href', window);
    return typeof href === 'string' && href.includes(VIEW.EXPORT_CHART);
};

export const addFullUrlToRequestHeader = (config: AxiosRequestConfig) => { 
    if (!isHeadlessMode() && !isExportPath() && !configService.isLocalDNSMapping()) {
        config.headers = config.headers || {};
        config.headers['x-redirect-after-fitch-login'] = get('location.href', window);
    }
    return config; 
};

export const extractTokenExpiryFromResponseHeader = (response: AxiosResponse) => { 
    const tokenExpiryMS = Number(response.headers['x-access-token-expires-at']);

    if (
        Number.isFinite(tokenExpiryMS)
    ) {
        TokenExpiryTimer.setNewExpiry(tokenExpiryMS);
    }

    return response; 
};
